import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Planner } from "@app/models/rest/planner";
import { ClientConfigService } from "@app/core/config/client-config.service";

@Injectable({
  providedIn: "root"
})
export class UserService {
  private clientConfigService = inject(ClientConfigService);
  private http = inject(HttpClient);

  private _planner: Planner;

  public getPlanner(): Promise<Planner> {
    return new Promise<Planner>((resolve, reject) => {
      if (this._planner) {
        resolve(this._planner);
      }
      this.http
        .get(this.clientConfigService.config.serviceUrl + "/planner", {
          withCredentials: true
        })
        .subscribe(
          (success: any) => {
            if (success && success.planner) {
              this._planner = success.planner;
              resolve(this._planner);
            } else if (success && success.message === "Not registered") {
              // User is not registered - create a specific error to handle this case
              const notRegisteredError = new Error("User not registered");
              (notRegisteredError as any).isNotRegistered = true;
              (notRegisteredError as any).originalResponse = success;
              reject(notRegisteredError);
            } else {
              reject("Could not retrieve current planner");
            }
          },
          (error) => reject(error)
        );
    });
  }

  public register(displayName: string, teamIds: number[]): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      if (!displayName || !teamIds) {
        reject("Missing registration details");
      } else {
        this.http
          .post(
            this.clientConfigService.config.serviceUrl + "/register/user",
            { displayName: displayName, teamIds: teamIds },
            { withCredentials: true }
          )
          .subscribe(
            (success: any) => {
              resolve(success);
            },
            (error) => reject(error)
          );
      }
    });
  }
}
